import React, { FC, Fragment } from 'react';
import { useObserver } from 'mobx-react-lite';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { TaxIdEntryStore } from '../TaxIdEntryStore';
import { TaxContext } from './TaxContext';
import { TaxIdContext } from './TaxIdContext';

interface Props {
  store: TaxIdEntryStore;
}

export const TaxIdContextSelector: FC<Props> = ({ store }) => {
  const { t } = useTranslation();

  function getOptionLabel(context: TaxIdContext) {
    switch (context.renderer) {
      case 'IndividualOptOut':
        return `${t('IndividualOut')} ${t('taxHelpIndividualNoTaxIdEntered')}`;
      case 'IndividualMultiple':
        return `${t('Individual')} ${t('taxHelpIndividualMultiple')}`;
      case 'IndividualStandard':
        return `${t('Individual')} ${t('taxHelpIndividual')}`;
      case 'IndividualMexico':
          return `${t('Individual')}`;
      case 'BusinessStandard':
      case 'BusinessEU':
        return `${t('Business')} ${t('taxHelpBusiness')}`;
      case 'BusinessMexico':
        return `${t('Business')}`;
      case 'BusinessMultiple':
        return t('Business');
      case 'BusinessAustraliaNewZealand':
        return t('Business');
      default:
        return '';
    }
  }
  const anzContextExists = store.taxIdContexts.some(
    (context) => context.renderer === 'BusinessAustraliaNewZealand'
  );
  return useObserver(() => (
    <>
      {anzContextExists &&
      <Form.Group>
        <Form.Check
          id="anz-check"
          type="checkbox"
          label={t('Business')}
          checked={store.anzEnabled}
          onChange={e => {
            const checked = e.currentTarget.checked;
            store.setAnzEnabled(checked);
            if (checked) {
              const context = store.taxIdContexts[0]; // or business context, based on your requirements
              store.selectTaxContext(context);
            } else {
              // Optionally, reset or clear the selected context when ANZ is disabled
              store.selectedContext = undefined;  // or select a default context
            }
          }}
        />
      </Form.Group>
}
      {/* Tax contexts */}
      {store.taxIdContexts.map(context => {
        if (context.renderer === 'BusinessAustraliaNewZealand') {
          // Only show ANZ context if checkbox is checked
          return store.anzEnabled ? (
            <Fragment key={context.id}>
              <TaxContext context={context} />
            </Fragment>
          ) : null;
        }

        // Other countries: radio buttons
        return (
          <Fragment key={context.id}>
            <Form.Check
              id={context.id}
              label={getOptionLabel(context)}
              type="radio"
              name="tax-context"
              onChange={() => store.selectTaxContext(context)}
              checked={store.selectedContext === context}
            />
            {store.selectedContext === context && <TaxContext context={context} />}
          </Fragment>
        );
      })}
    </>
  ));
};
